import 'react-datepicker/dist/react-datepicker.css';
import * as Yup from 'yup';
import { ErrorMessage, Formik } from 'formik';
import { Form } from 'react-bootstrap';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import { useLoginLazyQuery } from '../../../gql-types';
import AdminPageWrapper from '../../../components/common/wrappers/AdminPageWrapper';
import Button from '../../../components/common/buttons/Button';
import Loading from '../../../components/common/Loading';

export default function Login() {
    const history = useHistory();
    const { setToken, setAuthenticated } = useContext(ProfileContext);
    const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
    const [login, { loading, data, error }] = useLoginLazyQuery();

    const goBack = () => {
        history.push({
            pathname: '/',
        });
    };

    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('login');
        setRecaptchaToken(token);
    }, [executeRecaptcha]);

    useEffect(() => {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    useEffect(() => {
        if (data && data.login && data.login.token) {
            setAuthenticated(true);
            setToken(data.login.token);
            history.push('/admin');
        }
    }, [data]);

    if (loading) {
        return <Loading color="#23ab70" />;
    }

    const schema = Yup.object({
        username: Yup.string().required('Povinné pole'),
        password: Yup.string().required('Povinné pole'),
    });

    return (
        <AdminPageWrapper>
            <div className="admin-screen login-screen">
                <div className="admin-login-wrapper">
                    <Button className="primary-button" onClick={goBack}>
                        Zpět
                    </Button>
                    <Formik
                        validationSchema={schema}
                        onSubmit={async (values) => {
                            await handleReCaptchaVerify();
                            if (recaptchaToken) {
                                login({
                                    variables: {
                                        ...values,
                                    },
                                    context: {
                                        fetchPolicy: 'network-only',
                                    },
                                });
                            }
                        }}
                        initialValues={{
                            username: '',
                            password: '',
                        }}
                        validateOnChange={true}
                        validateOnBlur={true}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Row>
                                    <Form.Group controlId="username">
                                        <Form.Label>Přihlašovací jméno</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="username"
                                            value={values.username}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isValid={touched.username && !errors.username}
                                        />
                                        <ErrorMessage
                                            render={() => <div className="form-error">{errors.username}</div>}
                                            name={'username'}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="password">
                                        <Form.Label>Heslo</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isValid={touched.password && !errors.password}
                                        />
                                        <ErrorMessage
                                            render={() => <div className="form-error">{errors.password}</div>}
                                            name={'password'}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Button className="secondary-button secondary-button__margin" onClick={handleSubmit}>
                                    Přihlásit
                                </Button>
                                {error && <div className="form-error">Chyba přihlášení</div>}
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </AdminPageWrapper>
    );
}
